<template>
    <span>{{ formattedName }}</span>
</template>
<script>
    import _ from '@/common/helpers';
    import TimelineMessageDataTableModel from '@/common/models/timeline-message-data-table-model';

    export default {
        name: 'attribute-name',
        props: {
            name: {
                required: true,
            },
        },
        computed: {
            formattedName() {
                return this.name
                    .split(TimelineMessageDataTableModel.AttributeNameDelimiter)
                    .map(_.unCamelCase).join(' ');
            },
        },
    };
</script>
